import React from 'react';

const AboutUs = () => {
    return (
        <div className="container">
            <div className="d-lg-flex align-items-center">
                <div className="m-5">
                    <h1><span className="text-color">We</span> share knowledge with the world</h1>
                </div>
                <img className="img-fluid" src="https://about.udemy.com/wp-content/uploads/2021/07/about-us.png" alt="" />
            </div>
            <div className="text-center my-5">
                <h1>Changing learning for the <span className="text-color">better</span></h1>
                <p>Whether you want to learn or to share what you know,<br /> you’ve come to the right place. As a global destination for online learning, we connect people through knowledge.</p>
            </div>
            <div className="d-lg-flex gap-5 my-5">
                <div className="bg-success p-3 my-4 text-white">
                    <h5>In total, it was a big success, I would get emails about what a fantastic resource it was.</h5>
                    <h6>---"Mr. Dan Brown"</h6>
                </div>
                <div className="bg-secondary p-3 my-4 text-white">
                    <h5>We Learn responds to the needs of the business in an agile and global manner. It’s truly the best solution for our employees and their careers.</h5>
                    <h6>---"Cally Cuocko"</h6>
                </div>
                <div className="bg-info p-3 my-4 text-white">
                    <h5>We Learn fit us like a glove. Their team curates fresh, up-to-date courses from their marketplace and makes them available to customers.</h5>
                    <h6>---"Johnny Reeves"</h6>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;
